import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {
    AuthService,
    AuthenticationFacade,
    PARAM_RETURN_URL,
} from '@navfleet/client/authentication/domain/data-access';
import { NAV_ROUTES } from '@navfleet/client/navigation/domain/models';
import { TenantFacade } from '@navfleet/client/tenant/domain/data-access';
import { Observable } from 'rxjs';
import { combineLatestWith, filter, map, take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class AuthenticationGuard implements CanActivate {
    private readonly authFacade = inject(AuthenticationFacade);
    private readonly tenantFacade = inject(TenantFacade);
    private readonly router = inject(Router);
    private readonly authService = inject(AuthService);

    public canActivate(
        _next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.authFacade.isAuthenticated$.pipe(
            filter((v) => v !== null),
            combineLatestWith(this.tenantFacade.selectedTenant$),
            take(1),
            map(([isAuthenticated, isTenantSelected]) => {
                if (!isAuthenticated) {
                    this.authService.redirectToExternalLogin();
                    return false;
                } else if (!isTenantSelected) {
                    return this.navigateToLogin(state.url);
                }
                return true;
            })
        );
    }

    private navigateToLogin(url: string): UrlTree {
        return this.router.createUrlTree([NAV_ROUTES.LOGIN.path], {
            queryParams: { [PARAM_RETURN_URL]: url },
        });
    }
}
